export default "__VITE_ASSET__Iqj1ZeB$__"